
// 样式的可选类型
export const STYLE_TYPE_LIST = ['primary', 'success', 'warning', 'danger', 'info', 'default']
export const STYLE_TYPE_OBJ = {
  primary:'primary', success:'success', warning: 'warning', danger:'danger', info:'info', default:'default'
}

// 大小的可选类型
export const SIZE_TYPE_LIST = ['large', 'medium', 'small', 'mini']
export const SIZE_TYPE_OBJ = {large:'large', medium:'medium', small:'small', mini:'mini'}
